<template>
  <section ref="trainingSwiper" class="swiper">
    <div class="swiper__title">{{ slides[activeIndex].title }}</div>
    <div class="swiper-wrapper">
      <div
        v-for="(slide, i) in slides"
        :key="`Swiper-Slide_${i}`"
        class="swiper-slide"
      >
        <div class="swiper-slide__card" :class="activeIndex === i && 'active'">
          <div class="image">
            <img :src="`${mediaBaseUrl}${slide.image}`" />
          </div>
        </div>
      </div>
    </div>

    <div class="swiper-elements">
      <div class="swiper-pagination">
        <button
          v-for="(_, i) in slides"
          :key="`Swiper-Pagination-bullet_${i}`"
          @click="() => slideToLoop(i)"
          class="swiper-pagination__bullet"
          :class="activeIndex === i && 'active'"
        ></button>
      </div>

      <div class="swiper-button-prev" @click="prev"></div>
      <div class="swiper-button-next" @click="next"></div>
    </div>
  </section>
</template>

<script>
import Swiper from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export default {
  inject: ["mediaBaseUrl"],
  props: {
    slides: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      activeIndex: 0,
    };
  },
  mounted() {
    new Swiper(this.$refs.trainingSwiper, {
      loop: true,
      spaceBetween: "28.5px",
      slidesPerView: 1.4,
      centeredSlides: true,
      breakpoints: {
        // when window width is >= 700px
        700: {
          slidesPerView: 3,
          spaceBetween: "48px",
        },
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        type: "bullets",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      on: {
        slideChange: (trainingSwiper) => {
          this.activeIndex = trainingSwiper.realIndex;
        },
      },
    });
  },
  computed: {
    tracker() {
      return this.$root.$children[0].$refs.tracker
    },
  },
  methods: {
    next() {
      const trainingSwiper = this.$refs.trainingSwiper.swiper;
      trainingSwiper.slideNext();
      this.tracker.report('User_click_subscription_swiper_next')
    },
    prev() {
      const trainingSwiper = this.$refs.trainingSwiper.swiper;
      trainingSwiper.slidePrev();
      this.tracker.report('User_click_subscription_swiper_prev')
    },
    slideToLoop(index) {
      const trainingSwiper = this.$refs.trainingSwiper.swiper;
      trainingSwiper.slideToLoop(index);
      this.tracker.report('User_click_subscription_swiper_pagination')
    },
  },
};
</script>

<style scoped lang="sass">
.swiper
  width: 100%
  display: flex
  flex-direction: column
  padding-bottom: 20px
  padding-top: 34px
  min-height: fit-content
  align-items: center
  max-width: 802px!important

  &__title
    font-size: 24px
    font-weight: 700
    line-height: 33.6px
    text-align: center
    color: #1B2A3F
    margin-bottom: 21px

  &-slide
    display: flex
    justify-content: center
    align-items: center

    &__card
      height: 100%
      opacity: 0.2

      &.active
        opacity: 1

      .image
        object-fit: cover
        width: 235px
        height: 485px

        img
          height: 100%
          width: auto

  &-elements
    position: relative
    height: 34px
    width: 220px
    display: flex
    align-items: center
    justify-content: space-between
    margin-top: 30px

  &-pagination
    display: flex
    justify-content: center
    position: absolute
    align-items: center
    width: 100%
    bottom: 12px
    gap: 8px
    position: unset

    &__bullet
      padding: 5px
      border: none
      border-radius: 50%
      background: #FCF3FF
      cursor: pointer

      &.active
        background: #EC5EEC

  &-button
    &-next, &-prev
      bottom: 0
      top: unset
      border: 2px solid #EC5EEC
      border-radius: 400px
      width: 34px
      height: 34px

    &-next
      right: 0
      left: unset

      &:after
        content: url("/media/inpulse-template-ac-new-a/subscriptions/training/arrow-right.svg")
        font-size: unset

    &-prev
      left: 0
      right: unset

      &:after
        content: url("/media/inpulse-template-ac-new-a/subscriptions/training/arrow-left.svg")
        font-size: unset
</style>
